import React from 'react';
import { styled } from '@compiled/react';
import { JiraIcon } from '@atlaskit/logo';
import { Box, xcss } from '@atlaskit/primitives';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import MondayLogomark from '@atlassian/jira-illustrations/src/ui/adg4/thirdparty/logos/components/monday-logomark';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages';

export const MondayHierarchy = () => {
	const { formatMessage } = useIntl();

	return (
		<>
			<HeaderWrapper>
				<Box xcss={mondayIconStyles}>
					<MondayLogomark alt="Monday Icon" />
				</Box>
				<MondayHeader>{formatMessage(messages.mondayHeading)}</MondayHeader>
				<JiraIcon size="small" appearance="brand" />
				<Box xcss={jiraHeaderStyles}>{formatMessage(messages.jiraHeadingSpork)}</Box>
			</HeaderWrapper>
			<svg
				width="576"
				height="116"
				viewBox="0 0 576 116"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				role="img"
				aria-label={formatMessage(messages.illustrationLabel)}
			>
				<g id="MondayHierarchy">
					<g id="monday" clipPath="url(#clip6_15_137)">
						<g id="mondayBackground">
							<rect width="270" height="116" rx="6" fill="white" />
						</g>
						<g id="Image section view_2" clipPath="url(#clip7_15_137)">
							<g id="Group">
								<rect
									x="1"
									y="4.21819"
									width="209"
									height="31.6364"
									rx="6"
									fill="white"
									fillOpacity="0.01"
								/>
								<text
									fill="#216E4E"
									xmlSpace="preserve"
									fontSize="14"
									fontWeight="500"
									letterSpacing="0px"
								>
									<tspan x="53" y="25.1947">
										{formatMessage(messages.mondayGroup)}
									</tspan>
								</text>
								<g id="Icon_4">
									<rect
										width="24"
										height="24"
										transform="translate(24 8.21819)"
										fill="white"
										fillOpacity="0.01"
									/>
									<path
										d="M41.7071 17.5111C42.0697 17.8737 42.0956 18.4456 41.7848 18.8381L41.7071 18.9253L36.7071 23.9253C36.3444 24.2879 35.7726 24.3138 35.3801 24.003L35.2929 23.9253L30.2929 18.9253C29.9024 18.5348 29.9024 17.9016 30.2929 17.5111C30.6555 17.1485 31.2274 17.1226 31.6199 17.4334L31.7071 17.5111L36 21.8033L40.2928 17.5111C40.6555 17.1485 41.2273 17.1226 41.6199 17.4334L41.7071 17.5111Z"
										fill="#216E4E"
									/>
								</g>
							</g>
							<g id="Item">
								<path
									d="M27 36.5H235C238.038 36.5 240.5 38.9624 240.5 42V61.6364C240.5 64.6739 238.038 67.1364 235 67.1364H27C23.9624 67.1364 21.5 64.6739 21.5 61.6364V42C21.5 38.9624 23.9624 36.5 27 36.5Z"
									stroke="#DCDFE4"
								/>
								<path
									d="M21 41C21 38.7909 22.7909 37 25 37V37V67V67C22.7909 67 21 65.2091 21 63V41Z"
									fill="#216E4E"
								/>
								<g id="Nav Item_5">
									<rect
										x="29"
										y="36"
										width="209"
										height="31.6364"
										rx="6"
										fill="white"
										fillOpacity="0.01"
									/>
									<text
										fill="#626F86"
										xmlSpace="preserve"
										fontSize="14"
										fontWeight="500"
										letterSpacing="0px"
									>
										<tspan x="71" y="56.9766">
											{formatMessage(messages.mondayItem)}
										</tspan>
									</text>
									<g id="Icon_3">
										<rect
											width="24"
											height="24"
											transform="translate(40 40)"
											fill="white"
											fillOpacity="0.01"
										/>
										<path
											d="M57.7071 49.2929C58.0697 49.6555 58.0956 50.2274 57.7848 50.6199L57.7071 50.7071L52.7071 55.7071C52.3444 56.0697 51.7726 56.0956 51.3801 55.7848L51.2929 55.7071L46.2929 50.7071C45.9024 50.3166 45.9024 49.6835 46.2929 49.2929C46.6555 48.9303 47.2274 48.9044 47.6199 49.2152L47.7071 49.2929L52 53.5851L56.2928 49.2929C56.6555 48.9303 57.2273 48.9044 57.6199 49.2152L57.7071 49.2929Z"
											fill="#626F86"
										/>
									</g>
								</g>
							</g>
							<g id="Subitem">
								<g id="Nav Item_4">
									<rect
										x="57"
										y="74"
										width="184"
										height="31.6364"
										rx="6"
										fill="white"
										fillOpacity="0.01"
									/>
									<text
										fill="#626F86"
										xmlSpace="preserve"
										fontSize="14"
										fontWeight="500"
										letterSpacing="0px"
									>
										<tspan x="71" y="95.9766">
											{formatMessage(messages.mondaySubitem)}
										</tspan>
									</text>
								</g>
								<path
									d="M47 74.5H235C238.038 74.5 240.5 76.9624 240.5 80V99.6364C240.5 102.674 238.038 105.136 235 105.136H47C43.9624 105.136 41.5 102.674 41.5 99.6364V80C41.5 76.9624 43.9624 74.5 47 74.5Z"
									stroke="#DCDFE4"
								/>
								<path
									d="M41 79C41 76.7909 42.7909 75 45 75V75V105V105C42.7909 105 41 103.209 41 101V79Z"
									fill="#216E4E"
								/>
								<path
									d="M23 66.4364V89.4364H41"
									stroke="#216E4E"
									strokeLinecap="round"
									strokeLinejoin="round"
								/>
							</g>
						</g>
					</g>
					<g id="arrow-right">
						<rect
							width="32"
							height="32"
							transform="translate(272 42)"
							fill="white"
							fillOpacity="0.01"
						/>
						<path
							d="M288.391 65.6094C287.91 65.1288 287.873 64.3725 288.28 63.8494L288.391 63.7239L292.78 59.3346L280 59.3333C279.264 59.3333 278.667 58.7364 278.667 58C278.667 57.3162 279.181 56.7526 279.844 56.6756L280 56.6666L292.783 56.668L288.391 52.2761C287.91 51.7955 287.873 51.0392 288.28 50.5161L288.391 50.3905C288.871 49.9099 289.627 49.8729 290.151 50.2796L290.276 50.3905L296.943 57.0572L297.04 57.1661C297.043 57.1699 297.047 57.1738 297.05 57.1776L296.943 57.0572C296.99 57.1044 297.033 57.1542 297.072 57.2062C297.095 57.2384 297.118 57.2717 297.139 57.3058C297.149 57.3219 297.158 57.3381 297.167 57.3546C297.182 57.3809 297.195 57.4081 297.208 57.4359C297.219 57.4585 297.229 57.4816 297.238 57.5049C297.249 57.5312 297.258 57.5576 297.267 57.5844C297.274 57.6042 297.28 57.6247 297.286 57.6453C297.294 57.6741 297.3 57.703 297.306 57.7322C297.311 57.7555 297.315 57.7788 297.319 57.8021C297.323 57.8274 297.326 57.8535 297.328 57.8799C297.331 57.912 297.332 57.9431 297.333 57.9742C297.333 57.982 297.333 57.991 297.333 58L297.333 58.0258C297.332 58.0569 297.331 58.088 297.328 58.119L297.333 58C297.333 58.0675 297.328 58.1338 297.319 58.1986C297.315 58.2213 297.311 58.2445 297.306 58.2676C297.3 58.297 297.294 58.3259 297.286 58.3545C297.28 58.3753 297.274 58.3958 297.267 58.4162C297.258 58.4424 297.249 58.4687 297.239 58.4947C297.229 58.5183 297.219 58.5414 297.208 58.5643C297.195 58.5918 297.182 58.619 297.167 58.6457C297.158 58.6618 297.149 58.6781 297.139 58.6942C297.118 58.7283 297.095 58.7615 297.072 58.7935C297.066 58.8016 297.06 58.8094 297.054 58.8172C297.016 58.8646 296.981 58.9048 296.943 58.9428L290.276 65.6094C289.755 66.1301 288.911 66.1301 288.391 65.6094Z"
							fill={token('color.text.subtle', '#44546F')}
						/>
					</g>
					<g id="JWM hierarchy">
						<g clipPath="url(#clip0_15_137)">
							<rect x="306" y="-3.05176e-05" width="270" height="116" rx="6" fill="white" />
							<g id="Frame 1052" clipPath="url(#clip1_15_137)">
								<rect
									id="jwmBackground"
									x="306"
									y="-3.05176e-05"
									width="270"
									height="116"
									fill="#579DFF"
								/>
								<g
									id="Image section view"
									clipPath="url(#clip2_15_137)"
									filter="url(#filter0_dd_15_137)"
								>
									<g id="Epic">
										<path
											d="M320 19C320 15.6863 322.686 13 326 13H554C557.314 13 560 15.6863 560 19V37C560 40.3137 557.314 43 554 43H326C322.686 43 320 40.3137 320 37V19Z"
											fill="#6E5DC6"
										/>
										<rect
											id="Rectangle 1394"
											x="320"
											y="13"
											width="240"
											height="30"
											rx="6"
											fill="white"
										/>
										<g id="Nav Item_3">
											<rect
												x="320"
												y="13"
												width="209"
												height="30"
												rx="6"
												fill="white"
												fillOpacity="0.01"
											/>
											<text
												fill="#626F86"
												xmlSpace="preserve"
												fontSize="14"
												fontWeight="500"
												letterSpacing="0px"
											>
												<tspan x="392" y="32.9765">
													{formatMessage(messages.jiraEpic)}
												</tspan>
											</text>
											<g id="Icon_2">
												<rect
													width="24"
													height="24"
													transform="translate(336 16)"
													fill="white"
													fillOpacity="0.01"
												/>
												<path
													d="M353.707 25.2929C354.07 25.6555 354.096 26.2274 353.785 26.6199L353.707 26.7071L348.707 31.7071C348.344 32.0697 347.773 32.0956 347.38 31.7848L347.293 31.7071L342.293 26.7071C341.902 26.3166 341.902 25.6834 342.293 25.2929C342.656 24.9303 343.227 24.9043 343.62 25.2152L343.707 25.2929L348 29.585L352.293 25.2929C352.655 24.9302 353.227 24.9043 353.62 25.2152L353.707 25.2929Z"
													fill="#626F86"
												/>
											</g>
											<g id="epic" clipPath="url(#clip5_15_137)">
												<rect
													width="16"
													height="16"
													transform="translate(368 20)"
													fill="white"
													fillOpacity="0.01"
												/>
												<path
													fillRule="evenodd"
													clipRule="evenodd"
													d="M382 20C383.105 20 384 20.8954 384 22V34C384 35.1045 383.105 36 382 36H370C368.895 36 368 35.1045 368 34V22C368 20.8954 368.895 20 370 20H382ZM376.5 23C376.35 23 376.22 23.069 376.128 23.173L372.149 28.145C372.146 28.148 372.113 28.19 372.113 28.19C372.047 28.279 372 28.382 372 28.5C372 28.776 372.224 29 372.5 29C372.528 29 372.551 29.005 372.577 29H375V32.5C375 32.776 375.224 33 375.5 33C375.624 33 375.734 32.95 375.821 32.876C375.821 32.876 375.883 32.809 375.906 32.776L379.84 27.863C379.859 27.845 379.871 27.824 379.887 27.803L379.914 27.77C379.963 27.689 380 27.6 380 27.5C380 27.224 379.776 27 379.5 27H377V23.5C377 23.224 376.776 23 376.5 23Z"
													fill="#6554C0"
												/>
											</g>
										</g>
									</g>
									<g id="Task">
										<path
											d="M340 50C340 46.6863 342.686 44 346 44H554C557.314 44 560 46.6863 560 50V68C560 71.3137 557.314 74 554 74H346C342.686 74 340 71.3137 340 68V50Z"
											fill="white"
										/>
										<g id="Nav Item_2">
											<rect
												x="348"
												y="44"
												width="209"
												height="30"
												rx="6"
												fill="white"
												fillOpacity="0.01"
											/>
											<text
												fill="#626F86"
												xmlSpace="preserve"
												fontSize="14"
												fontWeight="500"
												letterSpacing="0px"
											>
												<tspan x="420" y="63.9765">
													{formatMessage(messages.jiraTask)}
												</tspan>
											</text>
											<g id="Icon">
												<rect
													width="24"
													height="24"
													transform="translate(364 47)"
													fill="white"
													fillOpacity="0.01"
												/>
												<path
													d="M381.707 56.2929C382.07 56.6555 382.096 57.2274 381.785 57.6199L381.707 57.7071L376.707 62.7071C376.344 63.0697 375.773 63.0956 375.38 62.7848L375.293 62.7071L370.293 57.7071C369.902 57.3166 369.902 56.6834 370.293 56.2929C370.656 55.9303 371.227 55.9043 371.62 56.2152L371.707 56.2929L376 60.585L380.293 56.2929C380.655 55.9302 381.227 55.9043 381.62 56.2152L381.707 56.2929Z"
													fill="#626F86"
												/>
											</g>
											<g id="jwm-item-type_task" clipPath="url(#clip4_15_137)">
												<path
													d="M396 53.6666C396 52.1939 397.194 51 398.667 51H409.333C410.806 51 412 52.1939 412 53.6666V64.3333C412 65.8061 410.806 67 409.333 67H398.667C397.194 67 396 65.8061 396 64.3333V53.6666Z"
													fill="#4C9AFF"
												/>
												<path
													fillRule="evenodd"
													clipRule="evenodd"
													d="M408.69 55.6099C409.09 55.9913 409.105 56.6243 408.723 57.0238L403.874 62.1045C403.348 62.6548 402.47 62.6548 401.945 62.1045L399.277 59.3095C398.895 58.91 398.91 58.277 399.31 57.8957C399.709 57.5143 400.342 57.529 400.723 57.9285L402.909 60.2184L407.277 55.6428C407.658 55.2433 408.291 55.2286 408.69 55.6099Z"
													fill="white"
												/>
											</g>
										</g>
									</g>
									<g id="Subtask">
										<path
											d="M360 81C360 77.6863 362.686 75 366 75H554C557.314 75 560 77.6863 560 81V99C560 102.314 557.314 105 554 105H366C362.686 105 360 102.314 360 99V81Z"
											fill="white"
										/>
										<g id="Nav Item">
											<rect
												x="376"
												y="75"
												width="184"
												height="30"
												rx="6"
												fill="white"
												fillOpacity="0.01"
											/>
											<text
												fill="#626F86"
												xmlSpace="preserve"
												fontSize="14"
												fontWeight="500"
												letterSpacing="0px"
											>
												<tspan x="421" y="95.9765">
													{formatMessage(messages.jiraSubtask)}
												</tspan>
											</text>
											<g id="subtask" clipPath="url(#clip3_15_137)">
												<rect
													width="16"
													height="16"
													transform="translate(397 82)"
													fill="white"
													fillOpacity="0.01"
												/>
												<path
													fillRule="evenodd"
													clipRule="evenodd"
													d="M406 89V86C406 85.7348 405.895 85.4804 405.707 85.2929C405.52 85.1053 405.265 85 405 85H401C400.735 85 400.48 85.1053 400.293 85.2929C400.105 85.4804 400 85.7348 400 86V90C400 90.2652 400.105 90.5195 400.293 90.7071C400.48 90.8946 400.735 91 401 91H404V94C404 94.2652 404.105 94.5195 404.293 94.7071C404.48 94.8946 404.735 95 405 95H409C409.265 95 409.52 94.8946 409.707 94.7071C409.895 94.5195 410 94.2652 410 94V90C410 89.7348 409.895 89.4804 409.707 89.2929C409.52 89.1053 409.265 89 409 89H406ZM397 83.994C397 82.893 397.895 82 398.994 82H411.006C412.107 82 413 82.895 413 83.994V96.006C413 96.5347 412.79 97.0418 412.416 97.4156C412.042 97.7895 411.535 97.9997 411.006 98H398.994C398.465 97.9997 397.958 97.7895 397.584 97.4156C397.21 97.0418 397 96.5347 397 96.006V83.994ZM406 91H408V93H406V91ZM402 87H404V89H402V87Z"
													fill="#2684FF"
												/>
											</g>
										</g>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
				<defs>
					<filter
						id="filter0_dd_15_137"
						x="312"
						y="4.99997"
						width="256"
						height="108"
						filterUnits="userSpaceOnUse"
						colorInterpolationFilters="sRGB"
					>
						<feFlood floodOpacity="0" result="BackgroundImageFix" />
						<feColorMatrix
							in="SourceAlpha"
							type="matrix"
							values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
							result="hardAlpha"
						/>
						<feOffset />
						<feGaussianBlur stdDeviation="4" />
						<feColorMatrix
							type="matrix"
							values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.16 0"
						/>
						<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_15_137" />
						<feColorMatrix
							in="SourceAlpha"
							type="matrix"
							values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
							result="hardAlpha"
						/>
						<feOffset />
						<feGaussianBlur stdDeviation="0.5" />
						<feColorMatrix
							type="matrix"
							values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.12 0"
						/>
						<feBlend
							mode="normal"
							in2="effect1_dropShadow_15_137"
							result="effect2_dropShadow_15_137"
						/>
						<feBlend
							mode="normal"
							in="SourceGraphic"
							in2="effect2_dropShadow_15_137"
							result="shape"
						/>
					</filter>
					<clipPath id="clip0_15_137">
						<rect x="306" y="-3.05176e-05" width="270" height="116" rx="6" fill="white" />
					</clipPath>
					<clipPath id="clip1_15_137">
						<rect width="270" height="116" fill="white" transform="translate(306 -3.05176e-05)" />
					</clipPath>
					<clipPath id="clip2_15_137">
						<rect width="240" height="92" fill="white" transform="translate(320 13)" />
					</clipPath>
					<clipPath id="clip3_15_137">
						<rect width="16" height="16" fill="white" transform="translate(397 82)" />
					</clipPath>
					<clipPath id="clip4_15_137">
						<rect width="16" height="16" fill="white" transform="translate(396 51)" />
					</clipPath>
					<clipPath id="clip5_15_137">
						<rect width="16" height="16" fill="white" transform="translate(368 20)" />
					</clipPath>
					<clipPath id="clip6_15_137">
						<rect width="270" height="116" fill="white" />
					</clipPath>
					<clipPath id="clip7_15_137">
						<rect width="240" height="97.0182" fill="white" transform="translate(1 8.43637)" />
					</clipPath>
				</defs>
			</svg>
		</>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const HeaderWrapper = styled.div({
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
	font: token('font.body.UNSAFE_small'),
	fontWeight: token('font.weight.semibold'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: token('color.text.subtle', colors.N700),
	marginBottom: token('space.100', '8px'),
	width: '100%',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const MondayHeader = styled.div({
	marginLeft: token('space.050', '4px'),
	width: '275px',
});

const jiraHeaderStyles = xcss({
	marginLeft: 'space.050',
});

const mondayIconStyles = xcss({
	width: 'space.300',
	height: 'space.300',
	paddingRight: 'space.050',
});
